import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const AuthService = {
  isAuthenticated() {
    const token = localStorage.getItem('access_token');
    return Boolean(token);
  },

  setAuthHeader() {
    const token = localStorage.getItem('access_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  },

  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    delete axios.defaults.headers.common['Authorization'];
  },

  async refreshToken() {
    const refresh = localStorage.getItem('refresh_token');
    if (!refresh) return false;

    try {
      const response = await axios.post(`${API_URL}/token/refresh/`, { refresh });
      const { access } = response.data;
      localStorage.setItem('access_token', access);
      this.setAuthHeader(); // ✅ Reaplica el token actualizado
      return true;
    } catch (err) {
      console.error('Error al refrescar el token:', err);
      this.logout();
      return false;
    }
  },
};

export default AuthService;